var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 22L0 22L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "estrella-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "estrella"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 22L0 22L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9479 8.43458C19.8169 7.98824 19.4577 7.67124 19.0328 7.62902L13.2602 7.05134L10.9776 1.16302C10.8093 0.731487 10.426 0.452148 10.0001 0.452148C9.57422 0.452148 9.19091 0.731487 9.0226 1.16403L6.73998 7.05134L0.966514 7.62902C0.542309 7.67224 0.184023 7.98824 0.0523365 8.43458C-0.0793503 8.88092 0.0422654 9.37048 0.363166 9.67908L4.72653 13.8966L3.43987 20.1431C3.34573 20.6024 3.50747 21.0771 3.85325 21.3526C4.0391 21.5006 4.25655 21.576 4.47582 21.576C4.66488 21.576 4.85242 21.5198 5.02073 21.4088L10.0001 18.1289L14.9776 21.4088C15.3419 21.6503 15.801 21.6283 16.146 21.3526C16.492 21.0763 16.6536 20.6014 16.5594 20.1431L15.2728 13.8966L19.6361 9.67992C19.957 9.37048 20.0796 8.88176 19.9479 8.43458L19.9479 8.43458Z",
    id: "Shape",
    fill: "#FF671D",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.89f691521ffb3ed4ade69d84d41beb9a.svg";
export { ForwardRef as ReactComponent };